import EventBus, { ACTIONS } from "../EventBus/EventBus";
export default {
  methods: {
    showSnackbar(message, type = "info", position = "right") {
      EventBus.$emit(ACTIONS.SNACKBAR, { message, type, position });
    }
  }
};
